/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline"; //CalendarIcon,
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, useLocation } from "react-router";

import { SelectorIcon } from "@heroicons/react/solid";

const navigation = [
    { name: "Home", href: "/dashboard" },
    { name: "Dashboard", href: "/dashboard-analytics" },
    { name: "Employees", href: "/employees" },
    { name: "Client", href: "/clients" },
    { name: "Timesheet", href: "/timesheet" },
    { name: "Payroll", href: "/payroll" },
    { name: "Payments", href: "/payments/invoice" },
];

const secondaryNavigation = [
    { name: "Settings", href: "/settings" },
    { name: "Help", href: "/help" },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function DefaultLayout() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();
    const { user, logout } = useAuth0();

    return (
        <>
            <header className="sticky top-0 z-20 bg-white shadow">
                <nav className="flex items-center justify-between px-4 py-3 mx-auto md:px-8" aria-label="Top">
                    <div className="flex items-center">
                        <a href="/dashboard">
                            <img className="w-auto h-10" src="/mti-logo.png" alt="MTINC" />
                        </a>
                        <div className="hidden space-x-4 md:flex md:ml-10">
                            {navigation.map((item) => (
                                <a key={item.name} href={item.href} className={classNames(location.pathname.startsWith(item.href) ? "text-indigo-600 font-semibold" : "text-gray-700 hover:text-indigo-600", "px-3 py-2 rounded-md text-sm")}>
                                    {item.name}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className="items-center hidden space-x-4 md:flex">
                        <Menu as="div" className="relative">
                            <Menu.Button className="flex items-center space-x-2 focus:outline-none">
                                <span className="text-sm font-bold text-gray-900">{user?.name || "Administrator"}</span>
                                <SelectorIcon className="w-5 h-5 text-gray-400" aria-hidden="true" />
                            </Menu.Button>
                            <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                                <Menu.Items className="absolute right-0 z-50 w-48 mt-2 origin-top-right bg-white border border-gray-200 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    <div className="py-1">
                                        <Menu.Item>
                                            {({ active }) => (
                                                <a href="/profile" className={classNames(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700")}>
                                                    View profile
                                                </a>
                                            )}
                                        </Menu.Item>
                                        <Menu.Item>
                                            {({ active }) => (
                                                <a href="/settings" className={classNames(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700")}>
                                                    Settings
                                                </a>
                                            )}
                                        </Menu.Item>
                                        <Menu.Item>
                                            {({ active }) => (
                                                <a href="/alerts" className={classNames(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700")}>
                                                    Notifications
                                                </a>
                                            )}
                                        </Menu.Item>
                                        <Menu.Item>
                                            {({ active }) => (
                                                <a href="/support" className={classNames(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700")}>
                                                    Support
                                                </a>
                                            )}
                                        </Menu.Item>
                                        <Menu.Item>
                                            {({ active }) => (
                                                <a onClick={() => logout({ returnTo: window.location.origin })} href="#" className={classNames(active ? "bg-gray-100" : "", "block px-4 py-2 text-sm text-gray-700")}>
                                                    Logout
                                                </a>
                                            )}
                                        </Menu.Item>
                                    </div>
                                </Menu.Items>
                            </Transition>
                        </Menu>
                    </div>
                    <div className="flex md:hidden">
                        <button type="button" className="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none" onClick={() => setMobileMenuOpen(true)}>
                            <span className="sr-only">Open main menu</span>
                            <MenuIcon className="block w-6 h-6" aria-hidden="true" />
                        </button>
                    </div>
                </nav>
                {/* Mobile menu */}
                <Transition show={mobileMenuOpen} as={Fragment}>
                    <Dialog as="div" className="fixed inset-0 z-40 md:hidden" onClose={setMobileMenuOpen}>
                        <div className="absolute inset-0 bg-gray-600 bg-opacity-75" />
                        <div className="fixed inset-0 z-50 flex">
                            <div className="relative flex flex-col flex-1 w-full max-w-xs bg-white focus:outline-none">
                                <div className="absolute top-0 right-0 pt-2 -mr-12">
                                    <button type="button" className="flex items-center justify-center w-10 h-10 ml-1 rounded-full focus:outline-none focus:bg-gray-600" onClick={() => setMobileMenuOpen(false)}>
                                        <span className="sr-only">Close sidebar</span>
                                        <XIcon className="w-6 h-6 text-white" aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="pt-5 pb-4">
                                    <div className="flex items-center px-4">
                                        <img className="w-auto h-10" src="/mti-logo.png" alt="MTINC" />
                                    </div>
                                    <nav className="px-2 mt-5 space-y-1">
                                        {navigation.map((item) => (
                                            <a key={item.name} href={item.href} className={classNames(location.pathname.startsWith(item.href) ? "bg-gray-100 text-indigo-600 font-semibold" : "text-gray-700 hover:bg-gray-50 hover:text-indigo-600", "block px-3 py-2 rounded-md text-base")} onClick={() => setMobileMenuOpen(false)}>
                                                {item.name}
                                            </a>
                                        ))}
                                    </nav>
                                    <div className="pt-4 mt-5 border-t border-gray-200">
                                        <div className="px-4">
                                            <div className="font-bold text-gray-900">{user?.name || "Administrator"}</div>
                                            <div className="text-xs text-gray-500">{user?.email || "Login Required"}</div>
                                        </div>
                                        <nav className="px-2 mt-3 space-y-1">
                                            {secondaryNavigation.map((item) => (
                                                <a key={item.name} href={item.href} className="block px-3 py-2 text-base text-gray-700 rounded-md hover:bg-gray-50 hover:text-indigo-600" onClick={() => setMobileMenuOpen(false)}>
                                                    {item.name}
                                                </a>
                                            ))}
                                            <a
                                                href="#"
                                                onClick={() => {
                                                    setMobileMenuOpen(false);
                                                    logout({ returnTo: window.location.origin });
                                                }}
                                                className="block px-3 py-2 text-base text-gray-700 rounded-md hover:bg-gray-50 hover:text-indigo-600"
                                            >
                                                Logout
                                            </a>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-shrink-0 w-14" aria-hidden="true"></div>
                        </div>
                    </Dialog>
                </Transition>
            </header>
            <div className="h-full min-h-screen py-0 pb-10 bg-gray-100">
                <Outlet />
            </div>
        </>
    );
}
